// extracted by mini-css-extract-plugin
module.exports = {"root":"ShimmerImage_root__AX0CP","hide":"ShimmerImage_hide__8gHe2","show":"ShimmerImage_show__iEF8u","shimmer":"ShimmerImage_shimmer__bH9Rx","hidden":"ShimmerImage_hidden__P38G7"};